import React, { useState } from "react";
import { connect } from "react-redux";
import { P, SubHeader } from "../../../../../UI toolkit/Text/Text";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import {
  SavingsTableHeaderStyle,
  SavingsTableStyle,
} from "./UserSavings.styled";
import ic_sent_icon from "../../../../../assets/images/ic-sent-coin.svg";
import ic_receive_icon from "../../../../../assets/images/ic-received-coin.svg";
import ic_swapped_coin from "../../../../../assets/images/ic-swapped-coin.svg";
import moment from "moment";
import { capitalizeFirstLetter } from "../../../../../utils/specialFunctions";
import { Badge } from "../../../../../UI toolkit/Button/Button";
import UserSavingModal from "./UserSavingModal";
import { Select } from "../../../../../UI toolkit/Dropdown/Dropdown";
import caret_down from "../../../../../assets/images/caret-down1.svg";
import { withTheme } from "styled-components";
import { setUserSavingsFilter } from "../../../../../store/Actions/SavingsActions";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

const UsersSavingsTable = ({ links1, theme, setFilter, filter }) => {
  const statusKeys = {
    stopped: "broken",
    active: "ongoing",
    completed: "completed",
    pending: "unclaimed",
    paid: "claimed",
  };

  const bgColor = (status) => {
    return status === "active" || status === "pending"
      ? "#FFEAB6"
      : status === "completed" || status === "paid"
      ? "#D1F7C4"
      : status === "stopped"
      ? "#FFDCE5"
      : "";
  };

  const color = (status) => {
    return status === "active" || status === "pending"
      ? "#606060"
      : status === "completed" || status === "paid"
      ? "#606060"
      : status === "stopped"
      ? "#531423"
      : "";
  };
  const [openModal, setopenModal] = useState(false);
  const [filterKeyword1, handlefilterKeyword1] = useState(false);
  const [savingsTypeFilterChanged, setSavingsTypeFilterChanged] = useState();
  const [saving, setSaving] = useState(null);

  const savingsTypeOptions = [
    { text: "Flexible", value: "flexible" },
    { text: "Fixed", value: "fixed" },
  ];

  const flexibleStatusOptions = [
    { text: "all", value: "all" },
    { text: "Ongoing", value: "active" },
    { text: "Completed", value: "completed" },
    { text: "Broken", value: "stopped" },
  ];
  const fixedStatusOptions = [
    { text: "all", value: "all" },
    { text: "Ongoing", value: "active" },
    { text: "Completed", value: "completed" },
    { text: "Unclaimed", value: "unclaimed" },
    { text: "Claimed", value: "claimed" },
  ];

  const statusOptions = [
    { text: "all", value: "all" },
    { text: "Ongoing", value: "active" },
    { text: "Completed", value: "completed" },
    { text: "Unclaimed", value: "unclaimed" },
    { text: "Claimed", value: "claimed" },
    { text: "Broken", value: "stopped" },
  ];

  return (
    <div style={{ overflowX: "auto" }}>
      <SavingsTableHeaderStyle className="w-full">
        <tbody className="w-full">
          <tr className="Table-heading -px-1.5">
            <td width="20%" className="pt-4 pb-4"></td>

            {/* <td width="15%" className="pt-4 pb-4">
              <div className="">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  USER
                </SubHeader>
              </div>
            </td> */}
            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  INVESTED
                </SubHeader>
              </div>
            </td>
            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  INTEREST
                </SubHeader>
              </div>
            </td>
            <td width="15%" className="pt-4 pb-4">
              <div className="flex justify-center">
                <SubHeader fontSize="12px" color={"#7C8191"} fontWeight="500">
                  PAYOUT
                </SubHeader>
              </div>
            </td>

            <td width="35%" className="w-full pt-4 pb-4 pr-6">
              <div className=" my-3 mx-3 lg:my-1.5 lg:mx-1.5 py-5 lg:py-0 w-full ">
                <div className="flex w-full ">
                  <div className="w-6/12 mr-2">
                    <Select
                      bgImg={caret_down}
                      // bgColor={"#112E46"}
                      // color={"#fff"}
                      bgColor={theme.colors.bg}
                      color={theme.colors.color}
                      border={"1px solid #fff"}
                      borderRadius={"4px"}
                      p={"5px 15px"}
                      data={savingsTypeOptions}
                      defaultValue={"-- Type --"}
                      properyToShow={"text"}
                      hoverBg={"#FFF"}
                      hoverColor={"#112E46"}
                      fontSize={"16px"}
                      callback={(option, idx, arr) => {
                        console.log(option, filter?.type);
                        // if (option.value !== filter?.type) {
                        //   setFilter({ type: option.value, status: undefined });
                        //   setSavingsTypeFilterChanged(true);
                        // } else {
                        //   setFilter({ ...filter, type: option.value });
                        // }
                        setFilter({ ...filter, type: option.value });
                      }}
                    />
                  </div>
                  <div className="w-6/12">
                    <Select
                      bgImg={caret_down}
                      // bgColor={"#112E46"}
                      // color={"#fff"}
                      bgColor={theme.colors.bg}
                      color={theme.colors.color}
                      border={"1px solid #fff"}
                      borderRadius={"4px"}
                      p={"5px 15px"}
                      data={
                        statusOptions
                        // filter?.type !== undefined
                        //   ? filter.type === "flexible"
                        //     ? flexibleStatusOptions
                        //     : fixedStatusOptions
                        //   : null
                      }
                      defaultValue={"-- Status --"}
                      properyToShow={"text"}
                      hoverBg={"#FFF"}
                      hoverColor={"#112E46"}
                      fontSize={"16px"}
                      callback={(option, idx, arr) => {
                        console.log(option, idx, arr);
                        if (option.text !== "all") {
                          setFilter({ ...filter, status: option.value });
                          console.log(filter);
                          // setSavingsTypeFilterChanged(false);
                        } else {
                          // setSavingsTypeFilterChanged(false);
                          setFilter({ ...filter, status: undefined });
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </SavingsTableHeaderStyle>
      {links1 &&
        links1.map((transactionGroup, idx, arr) => {
          return (
            <SavingsTableStyle className="w-full" key={idx}>
              <tbody>
                <tr>
                  <td colSpan="5">
                    <div className="pt-4 pb-4 px-1.5">
                      <P fontSize="13px" color={"#7C8191"} fontWeight="500">
                        {`${timeAgo.format(
                          new Date(transactionGroup.group)
                        )} — ${new Date(
                          transactionGroup.group
                        ).toDateString()}`}
                      </P>
                    </div>
                  </td>
                </tr>

                {transactionGroup.data.map((curr, idx, arr) => {
                  return (
                    <tr
                      className="px-1.5"
                      style={{ borderBottom: "1px solid #EFF0F5" }}
                      key={idx}
                    >
                      <td
                        width="20%"
                        className="pt-4 pb-4 col-start-1 col-end-2"
                      >
                        <div className="flex">
                          <div className="pr-2">
                            <img
                              src={
                                curr.savings_type.type === "fixed"
                                  ? ic_sent_icon
                                  : curr.savings_type.type === "flexible"
                                  ? ic_receive_icon
                                  : curr.savings_type.type === "swap"
                                  ? ic_swapped_coin
                                  : ""
                              }
                              className="h-auto w-auto"
                            />
                          </div>
                          <div>
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >{`${capitalizeFirstLetter(
                              curr.savings_type.type
                            )}`}</P>
                            <P fontSize="10px" color={"#7A809B"}>
                              {
                                new Date(curr.created_at)
                                  .toLocaleString()
                                  .split(",")[1]
                              }
                            </P>
                          </div>
                        </div>
                      </td>
                      <td width="15%">
                        <div className="flex justify-center">
                          <div>
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              {`${
                                curr.currency === "USDT"
                                  ? "$"
                                  : curr.currrency === "NGN"
                                  ? "₦"
                                  : ""
                              } ${Number(curr.amount).toFixed(2)}`}
                            </P>
                            <P
                              fontSize="10px"
                              color={"#7A809B"}
                              fontWeight="400"
                            >
                              {`${
                                curr &&
                                curr.savings_type &&
                                curr.savings_type.duration
                                  ? curr.savings_type.duration
                                  : ""
                              } months at ${
                                curr &&
                                curr.savings_type &&
                                curr.savings_type.interest
                                  ? curr.savings_type.interest
                                  : ""
                              } %`}
                            </P>
                          </div>
                        </div>
                      </td>
                      <td width="15%">
                        <div className="flex justify-center items-start">
                          <P fontSize="13px" color={"#374072"} fontWeight="500">
                            {`${
                              curr.currency === "USDT"
                                ? "$"
                                : curr.currrency === "NGN"
                                ? "₦"
                                : ""
                            } ${Number(curr.interest).toFixed(2)}`}
                          </P>
                        </div>
                        {curr.savings_type.type === "fixed" && (
                          <div className="flex justify-center">
                            <Badge
                              color={color(curr.interest_status)}
                              bg={bgColor(curr.interest_status)}
                              style={{ fontSize: "8px", padding: "0.3em 1em" }}
                            >
                              {statusKeys[curr.interest_status]}
                            </Badge>
                          </div>
                        )}
                      </td>
                      <td width="15%">
                        <div className="flex justify-center">
                          <div>
                            <P
                              fontSize="13px"
                              color={"#374072"}
                              fontWeight="500"
                            >
                              {`${
                                curr.currency === "USDT"
                                  ? "$"
                                  : curr.currrency === "NGN"
                                  ? "₦"
                                  : ""
                              } ${Number(curr.payout).toFixed(2)}`}
                            </P>
                            <P
                              fontSize="10px"
                              color={"#7A809B"}
                              fontWeight="400"
                            >
                              {`Exp ${
                                curr && curr.savings_type && curr.end_date
                                  ? moment(curr.end_date).format("L")
                                  : ""
                              } `}
                            </P>
                          </div>
                        </div>
                      </td>
                      <td width="15%" className="pt-4 pb-4 px-1.5">
                        <div className="flex justify-center">
                          <div className="">
                            <P
                              fontSize="13px"
                              color={"#0087B5"}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSaving(curr);
                                setopenModal(true);
                              }}
                            >
                              View
                            </P>
                          </div>
                        </div>
                      </td>
                      <td width="20%" className="pt-4 pb-4 px-1.5">
                        <div className="flex justify-center">
                          <Badge
                            color={color(curr.status)}
                            bg={bgColor(curr.status)}
                          >
                            {statusKeys[curr.status]}
                          </Badge>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </SavingsTableStyle>
          );
        })}

      <div>
        {openModal ? (
          <UserSavingModal
            width={"30%"}
            border={"none"}
            closeModalCallback={() => {
              setopenModal(false);
            }}
            saving={saving}
          />
        ) : null}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    filter: state.savings.user_savings_filter,
  };
};

// Link Actions to component
const mapDispatchToProps = (dispatch) => {
  return {
    setFilter: (payload) => dispatch(setUserSavingsFilter(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTheme(UsersSavingsTable));
